/**
 * @generated SignedSource<<165acbf7e0b3def6ecf8252700f0f642>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
export type SearchResultType = "ask" | "attachment" | "blogpost" | "board" | "code" | "comment" | "component" | "dashboard" | "database" | "document" | "embed" | "filter" | "focus_area" | "focus_area_status_update" | "folder" | "goal" | "goal_update" | "issue" | "learning" | "message" | "object" | "organization" | "organization_status_update" | "page" | "plan" | "playlist" | "position" | "presentation" | "project" | "project_update" | "question" | "repository" | "risk" | "schema" | "slide" | "space" | "spreadsheet" | "tag" | "type" | "unrecognised" | "video" | "whiteboard" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type searchLoomVideo_AtlassianSearchPage$data = {
  readonly creatorName: string | null;
  readonly description: string;
  readonly durationSeconds: number | null;
  readonly id: string;
  readonly title: string;
  readonly type: SearchResultType;
  readonly url: string;
  readonly " $fragmentType": "searchLoomVideo_AtlassianSearchPage";
};
export type searchLoomVideo_AtlassianSearchPage$key = {
  readonly " $data"?: searchLoomVideo_AtlassianSearchPage$data;
  readonly " $fragmentSpreads": FragmentRefs<"searchLoomVideo_AtlassianSearchPage">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "searchLoomVideo_AtlassianSearchPage",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "id"
    },
    {
      "kind": "ScalarField",
      "name": "title"
    },
    {
      "kind": "ScalarField",
      "name": "description"
    },
    {
      "kind": "ScalarField",
      "name": "type"
    },
    {
      "kind": "ScalarField",
      "name": "url"
    },
    {
      "kind": "ScalarField",
      "name": "durationSeconds"
    },
    {
      "kind": "ScalarField",
      "name": "creatorName"
    }
  ],
  "type": "SearchResultLoomVideo"
};

(node as any).hash = "a56882fcd089b08168614f4c51522fb3";

export default node;
